import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import TextField from "@material-ui/core/TextField";
import MaterialTable from "material-table";
import Typography from "@material-ui/core/Typography";
//Select imports from material ui
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// import Button from '@material-ui/core/Button';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import { Form, Row, Col, Dropdown, DropdownButton } from "react-bootstrap";
import { userRequestForOfs } from "../apiRoutes/apiRoutes";
import { sanitizeHtml } from "../domPurify/domPurify";
const useStyles = makeStyles((theme) => ({
  modal: {
    height: "100%",
    width: "100%",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    marginLeft: 0,
  },
  sizeInc: {
    width: "150%",
  },
  buttonSubmit: {
    //    marginTop:'150px'
  },
  paper: {
    height: "auto",
    // width: '90%',
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "linear-gradient(to bottom, #abbaab, #ffffff)",
    border: "2px solid #000",
    borderRadius: "1rem",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    position: "absolute",
    top: "50px",
    left: "30%",
    marginTop: "-50px",
    marginLeft: "-50px",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    marginTop: "3",
    float: "right",
  },
  root: {
    "& .super-app-theme--header": {
      backgroundColor: "black",
      color: "white",
    },
  },
}));

export const Department = () => {
  // console.clear()
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openR, setOpenR] = React.useState(false);
  const handleOpenR = () => {
    setOpenR(true);
  };
  const handleCloseR = () => {
    setOpenR(false);
  };

  const [isDisabled, setIsDisabled] = useState(false);

  // States
  const [departData, setDepartData] = useState([]);
  // form states
  const [depart, setDepart] = useState("");
  const [relatedTo, setRelatedTo] = useState("");
  const [category, setCategory] = useState("");
  const [response, setResponse] = useState("");
  const [comments, setComments] = useState("");

  // Functions
  const getDepart = async () => {
    let api = "/department/SelectDepartment";
    let fd = await userRequestForOfs.get(api);
    setDepartData(fd.data.data);
    console.log("dept data ===>", fd.data.data);
  };

  useEffect(() => {
    getDepart();
  }, []);

  function formClear() {
    setDepart("");
    setRelatedTo("");
    setCategory("");
    setResponse("");
    setComments("");
  }

    // Sanitize Inputs from xss attacks
    const sanitizeDepart = sanitizeHtml(depart);

  //Month Work
  let MonthArr = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let getCurrentMonth = MonthArr[new Date().getMonth()];
  console.log(getCurrentMonth);

  //Form Submit Handler
  const submitHandler = (e) => {
    e.preventDefault();
    console.log("departement name ===>", depart);
    setIsDisabled(true);
    if (!depart) {
      toast.error("Please write Department!");
      e.preventDefault();
      e.stopPropagation();
      setIsDisabled(false);

      return;
    }

    userRequestForOfs
      .post("/department/createDepartment", {
        DepartName: depart,
        submittedBy: localStorage.getItem("username"),
      })
      .then((res) => {
        console.log(res);
        toast.success(res.data.message);
        setIsDisabled(false);

        if (res.status === 200) {
          setOpenR(false);
          formClear();
          getDepart();
          // console.log(tableDATA)
          console.log(res.data.message);
          console.log("ddddddddddddd" + res.status);
          // } else {
          //   setOpenR(true);
          //   console.log(res.data.message);
        }
      })
      .catch((error) => {
        // error from catch
        console.log("error from catch ==>", error);
        if (error.message === "Network Error") {
          console.log("i am here");
          toast.error("Server Error!");
          setIsDisabled(false);
          return;
        } else if (error.response.status === 409) {
          toast.error("Department already Exist");
          setIsDisabled(false);
          return;
        } else {
          toast.error("Error !");
          return;
        }
      });
  };
  return (
    <div className="DHContainer">
      <div>
        <Button
          type="button"
          onClick={handleOpenR}
          variant="contained"
          color="secondary"
          className={classes.button}
          startIcon={<AddCircleOutlineIcon />}
        >
          Add Department
        </Button>
        <Dialog
          fullScreen={fullScreen}
          open={openR}
          onClose={handleCloseR}
          aria-labelledby="responsive-dialog-title"
          PaperProps={{
            style: {
              background: "linear-gradient(to right, #e0eafc, #cfdef3)",
              width: "600px",
            },
          }}
        >
          <DialogTitle id="responsive-dialog-title">
            {/* <img
              src="/icon/alert1.png"
              alt="alertimage"
              width="60px"
              height="50px"
            ></img> */}
            <Typography
              component="h1"
              variant="h5"
              style={{
                color: "black",
                fontWeight: "bolder",
                fontFamily: "ariel",
              }}
            >
              Add Department
            </Typography>
          </DialogTitle>

          <DialogContent>
            <form className="dhForm" noValidate onSubmit={submitHandler}>
              <div className="div1t6 w-100">
                <InputLabel id="demo-simple-select-label" className="w-100">
                  Department Name
                </InputLabel>
                <div>
                  <FormControl
                    required
                    className={`w-100 ${classes.formControl}`}
                  >
                    <Form.Group
                      as={Col}
                      md="8"
                      className="w-100"
                      controlId="validationCustom01"
                    >
                      {/* <Form.Label>Name :</Form.Label> */}
                      <Form.Control
                        type="text"
                        placeholder="Enter Department Name"
                        className="w-100"
                        value={sanitizeDepart}
                        onChange={(e) => setDepart(e.target.value)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide a valid Department name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </FormControl>
                </div>
                {/* <div className="w-100 d-flex justify-content-between  ">
                  <Button
                    className="dialog-btn close-btn-abc"
                    onClick={() => handleCloseR()}
                  >
                    Close
                  </Button>
                  <Button className="dialog-btn" type="submit">
                    Submit
                  </Button>
                </div> */}
                <div className="test-TwoBtn">
                  <div>
                    {isDisabled ? (
                      <Button type="submit" className="dialog-btn" disabled>
                        Save
                      </Button>
                    ) : (
                      <Button type="submit" className="dialog-btn">
                        Save
                      </Button>
                    )}
                  </div>
                  <div>
                    <Button
                      className="dialog-btn close-btn-abc"
                      onClick={() => handleCloseR()}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </div>
      <div style={{ maxWidth: "100%", marginTop: "1rem" }}>
        <MaterialTable
          title="Departments"
          columns={[
            // {
            //   field: "id",
            //   title: "ID",
            //   cellStyle: {
            //     backgroundColor: "#74F700",
            //     color: "#FFF",
            //   },
            //   headerStyle: {
            //     backgroundColor: "#74F700",
            //   },
            // },
            { field: "DepartName", title: "Department Name" },
            //{ field: "tableData", title: "Table Data" },
          ]}
          data={departData}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  const dataUpdate = [...departData];
                  const index = oldData.id;

                  // console.log(index)
                  dataUpdate[index] = newData;
                  userRequestForOfs
                    .post(
                      "/department/updateDepart",
                      newData
                    )
                    .then((res) => {
                      if (res.status === 200) {
                        console.log("updatedSuccessfully");
                        console.log(newData);
                        getDepart();
                        toast.success("Update successfully !");
                      }
                      // else {
                      //   console.log(res.data.message);
                      //   console.log(newData);
                      //   toast.error("Error !");
                      // }
                    })
                    .catch((error) => {
                      // error from catch
                      console.log("error from catch ==>", error);
                      if (error.message === "Network Error") {
                        console.log("i am here");
                        toast.error("Server Error!");
                        setIsDisabled(false);
                        return;
                      } else if (error.response.status === 409) {
                        toast.error("Department already Exist");
                        setIsDisabled(false);
                        return;
                      } else {
                        toast.error("Error !");
                        return;
                      }
                    });
                  // setCauseData([...dataUpdate]);
                  resolve();
                }, 1000);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  const index = oldData.id;
                  userRequestForOfs
                    .post(
                      "/department/deleteDepartment",
                      {
                        id: index,
                      }
                    )
                    .then((res) => {
                      if (res.status === 200) {
                        console.log("updatedSuccessfully");
                        // console.log(newData);
                        getDepart();
                        toast.info("Delete successfully !");
                        // } else {
                        //   console.log(res.data.results);
                        //   // console.log(newData);
                        //   toast.error("Error !");
                      }
                    })
                    .catch((error) => {
                      // error from catch
                      console.log("error from catch ==>", error);
                      if (error.message === "Network Error") {
                        console.log("i am here");
                        toast.error("Server Error!");
                        setIsDisabled(false);
                        return;
                      } else if (error.response.status === 404) {
                        console.log("i am network error", error.message);
                        toast.error("Please Check your Internet!");
                        setIsDisabled(false);
                        return;
                      } else {
                        toast.error("Error !");
                      }
                    });

                  resolve();
                }, 1000);
              }),
          }}
          options={{
            filtering: true,
            exportButton: true,
            // pageSizeOptions: [5, 10, 20,{ value: tableDATA.data.length, label: 'All' }],
            headerStyle: {
              backgroundColor: "#77C9C1",
              color: "black",
            },
          }}
        />
      </div>
    </div>
  );
};
